module.exports = __webpack_public_path__ + "static/img/LOGO.8b524974.png";